export const RESET_PASSWORD_COMPLETE = 'RESET_PASSWORD_COMPLETE';

export const RESET_PASSWORD_PENDING = 'RESET_PASSWORD_PENDING';

export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const RESET_REDUCER = 'RESET_REDUCER';
